
/*!
 * @pendo/components 3.25.3
 * (c) 2018-present
 */

import 'lodash/isNumber';
import { n as nextFrame } from './table-auto-height-mixin.js';
import { ObserveVisibility } from 'vue-observe-visibility';

async function scaleToFit({
  element,
  offset = 32,
  aspectRatio,
  maxScale
} = {}) {
  let scale = 1;

  if (!element.parentElement) {
    return;
  }

  element.parentElement.style.overflow = 'hidden';

  if (['relative', 'absolute', 'fixed'].indexOf(window.getComputedStyle(element.parentElement, null).getPropertyValue('position')) === -1) {
    element.parentElement.style.position = 'relative';
  }

  element.style.position = 'absolute';
  element.style.transformOrigin = 'left top';
  await nextFrame();
  let elementWidth = element.offsetWidth;
  const elementHeight = element.offsetHeight;
  let containerWidth = element.parentElement.offsetWidth;
  let containerHeight = element.parentElement.offsetHeight;
  containerWidth -= offset;
  containerHeight -= offset;

  if (aspectRatio) {
    elementWidth = Math.max(elementWidth, Math.round(elementHeight * aspectRatio));
    element.style.width = `${elementWidth}px`;
  }

  const boundRatioX = containerWidth / elementWidth;
  const boundRatioY = containerHeight / elementHeight;
  scale = boundRatioX < boundRatioY ? boundRatioX : boundRatioY;

  if (maxScale) {
    scale = Math.min(scale, maxScale);
  }

  const targetWidth = Math.round(elementWidth * scale);
  const targetHeight = Math.round(elementHeight * scale);
  containerHeight += offset;
  containerWidth += offset;
  element.style.transform = `scale(${scale})`;
  element.style.left = `${Math.round((containerWidth - targetWidth) * 0.5)}px`;
  element.style.top = `${Math.round((containerHeight - targetHeight) * 0.5)}px`;
}

var script = {
  directives: {
    ObserveVisibility
  },
  props: {
    layout: {
      type: Object,
      required: true
    },
    offset: {
      type: Number,
      default: 32
    }
  },

  data() {
    return {
      isHidden: true
    };
  },

  computed: {
    isMobileLayout() {
      return this.layout.supportedPlatforms && this.layout.supportedPlatforms.mobile;
    },

    isWebLayout() {
      return this.layout.supportedPlatforms && this.layout.supportedPlatforms.web;
    }

  },
  methods: {
    async handleVisibilityChange(isVisible) {
      if (isVisible) {
        await nextFrame();

        if (window.pendo) {
          window.pendo.flexElement(this.$el);
        }

        await this.scaleLayoutPreview();
        await nextFrame();
        this.isHidden = false;
      } else {
        this.isHidden = true;
      }
    },

    async scaleLayoutPreview() {
      const scaleConfig = {
        element: this.$el,
        offset: this.offset
      };

      if (this.layout.type && this.layout.type.includes('mobilePopUpBlank')) {
        scaleConfig.offset = 64;
      }

      if (this.isMobileLayout) {
        scaleConfig.aspectRatio = 9 / 16;
        scaleConfig.maxScale = 1;
      }

      await scaleToFit(scaleConfig);
    }

  }
};

const __vue_script__ = script;

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    directives: [{
      name: "observe-visibility",
      rawName: "v-observe-visibility",
      value: _vm.handleVisibilityChange,
      expression: "handleVisibilityChange"
    }],
    staticClass: "pendo-layout-preview",
    class: {
      'pendo-layout-preview--mobile': _vm.isMobileLayout,
      'pendo-layout-preview--web': _vm.isWebLayout,
      'is-hidden': _vm.isHidden
    },
    domProps: {
      "innerHTML": _vm._s(_vm.layout.previewHTML)
    }
  });
};

var __vue_staticRenderFns__ = [];
const __vue_inject_styles__ = undefined;
const __vue_scope_id__ = undefined;
const __vue_is_functional_template__ = false;

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "pendo-layout-preview.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var PendoLayoutPreview = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__);

export default PendoLayoutPreview;
